import React from 'react'
import {
    Typography,
    Grid,
    Paper,
    Button
} from '@material-ui/core/index'
import useStyles from './AdviceCardStyles'

function AdviceCard({advice, reportSpam}) {
    const classes = useStyles()

    return (
        <Paper className={classes.introPaper}>
            <Grid 
                container 
                align='center' 
                justify='center'
                spacing={2}
            >
                <Grid item xs={12}>
                    <Typography variant='h5' > {advice.message} </Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant='outlined'
                        onClick={() => reportSpam(advice)}
                    >
                        Report Spam
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default AdviceCard